import PropTypes from 'prop-types';
import React from 'react';

import {DateTime} from 'luxon';

import Link from './Link';
import TagList from './TagList';

export default class Project extends React.Component {
	static propTypes = {
		date: PropTypes.string.isRequired,
		featured: PropTypes.bool,
		path: PropTypes.string,
		suffix: PropTypes.string,
		summary: PropTypes.string,
		taskSummary: PropTypes.string,
		title: PropTypes.string.isRequired,
		url: PropTypes.string,
	}

	static defaultProps = {
		featured: false,
	}

	render() {
		const {
			date,
			featured,
			path,
			suffix,
			summary,
			taskSummary,
			title,
			url,
		} = this.props;

		const parsedDate = DateTime.fromISO(date);
		let dateString;
		if (/^\d\d\d\d$/.test(date)) {
			dateString = parsedDate.toFormat('yyyy');
		} else  {
			dateString = parsedDate.toFormat('MMMM yyyy');
		}

		let wrappedTitle = <strong>{title}</strong>;
		if (featured && path || url) {
			wrappedTitle = <Link to={path ? path : url}>{wrappedTitle}</Link>;
		}

		return (
			<div className="project">
				<span className="project__date">
					<time dateTime={date}>
						{dateString}
					</time>
				</span>
				{": "}
				<span className="project__title">
					{wrappedTitle}
				</span>
				{summary &&
					<React.Fragment>
						{" – "}
						<span className="project__summary">
							{summary}
						</span>
					</React.Fragment>
				}
				{taskSummary &&
					<React.Fragment>
						{" "}
						<span className="project__task-summary">
							({taskSummary})
						</span>
					</React.Fragment>
				}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Project.js